module.exports = __webpack_public_path__ + "img/pg5-right1.965d0d82.png";